
<div class="flow-loader" :position="position">
	<Icon name="loading" :size="size" :effects="false" :state="state" type="outlined" />
	<slot />
</div>
